/**
 * AI.GEN lines=1-50
 * 主机配置 - 根据环境和国家代码获取对应的 API 地址
 */
import { ICountryCode } from '@/config/country';

type IHost = {
  [key in ICountryCode]?: {
    SERVER_BASE_API: string;
    SERVER_URMS_URL: string;
  };
};

const getHostConfig = (): IHost => {
  const env = process.env.environment || 'test';

  // 根据环境返回不同的配置
  const hostMap: Record<string, IHost> = {
    test: {
      NZ: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      EUR: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      US: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      CA: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      AU: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      SG: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      GB: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      KR: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
      CN: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
    },
    dev: {
      CN: {
        SERVER_BASE_API: 'https://test-gateway.hungrypanda.cn',
        SERVER_URMS_URL: 'https://f2e-urms-test.hungrypanda.cn/ssoLogin',
      },
    },
    beta: {
      CN: {
        SERVER_BASE_API: 'https://beta-gateway.hungrypanda.it',
        SERVER_URMS_URL: 'https://f2e-urms-beta.hungrypanda.it/ssoLogin',
      },
    },
    release: {
      CN: {
        SERVER_BASE_API: 'https://gateway.hungrypanda.co',
        SERVER_URMS_URL: 'https://urms.hungrypanda.co/ssoLogin',
      },
    },
  };

  return hostMap[env] || hostMap.test;
};

export const host = getHostConfig();
